<template>
  <!-- :height="(windowHeight-48)+'px'" -->
  <div>
    <iframe
      id="_mainIframe"
      src="https://user.zxxk.com/bookshop/page"
      width="100%"
      allowfullscreen="true"
      :height="windowHeight + 'px'"
      frameborder="no"
    ></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {
      windowHeight: 0,
    };
  },
  mounted() {
    this.windowHeight = window.innerHeight;
    window.addEventListener(
      "message",
      function (event) {
        var data = event.data;
        // console.log("data-----------", data);
        let frm = document.getElementById("_mainIframe");
        if (typeof data == "string") {
          if (data.indexOf("height") > -1) {
            var idx = data.indexOf(":");
            frm.setAttribute(
              "height",
              parseInt(data.substring(idx + 1, data.length))
            );
          }
        }
      },
      false
    );
    // setInterval(() => {
    //   console.log('定时器----')
    //   this.reinitIframe();
    // }, 200);
  },
  methods: {
    // document.domain = "caibaojian.com";
    setIframeHeight(iframe) {
      if (iframe) {
        var iframeWin =
          iframe.contentWindow || iframe.contentDocument.parentWindow;
        if (iframeWin.document.body) {
          iframe.height =
            iframeWin.document.documentElement.scrollHeight ||
            iframeWin.document.body.scrollHeight;
        }
      }
    },
    reinitIframe() {
      var iframe = document.getElementById("_mainIframe");
      console.log("iframe", iframe);
      try {
        var bHeight = iframe.contentWindow.document.body.scrollHeight;
        var dHeight =
          iframe.contentWindow.document.documentElement.scrollHeight;
        var height = Math.max(bHeight, dHeight);
        iframe.height = height;
        console.log("height", height);
      } catch (ex) {}
    },
  },
};
</script>
<style lang="scss" scoped>
.right-content {
  padding-left: 30px;
}
iframe {
  margin: 0 auto;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  // margin-top: 48px;
  // scrolling: no; /* 确保不显示滚动条 */
}
</style>
